module.exports = __webpack_public_path__ + "img/sign_up_page_02.fb4d1568.jpg";